module.exports = __webpack_public_path__ + "static/img/mobile-icon.e6ada86e.png";